import { FAQS, REGISTRATION_CARDS, TERMS_AND_CONDITION } from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/NCAA/I-State_3Color.png";
const StaticBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Cyclone%20Ticket%20Upgrades_1920x450.png";
const MobileStaticBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Cyclone%20Ticket%20Upgrades_375x550.png";
const BackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Iowa%20State/Cyclone%20Ticket%20Upgrades2_1920x1080.png";

export const iowastate_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "iowastate_upgrades",
  TEAM_FULL_NAME: "Iowa State",
  BROWSER_TITLE: "Iowa State Upgrades",
  CLIENT_ID: "19a40b80a8b7.seasonshare.isu-isu.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C8102E",
    COLORS_SECONDARY: "#CAC7A7",
    IS_INTERCOM_ENABLED: false,
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      IS_EXPANDED_CARD: true,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      HIDE_EVENT_LOGO: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () =>
          "Thank you for your purchase. You have successfully purchased an upgrade for today's Iowa State game.",
      },
    },
    // "check for event on account prior to showing upgrades":
    // shown when the logged-in account has no eligible event/ticket.
    ZERO_STATE: {
      TITLE: "No Available Upgrades",
      DESCRIPTION:
        "You must have a valid game ticket to today's game in order to participate in this exclusive opportunity. Offer valid for select seating areas.",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    LANDING_PAGE_STATIC_BANNER_URL: StaticBannerImage,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileStaticBannerImage,
    ORDER_SUMMERY_BACKGROUND_URL: BackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
